module.exports = __webpack_public_path__ + "img/app.8798ec01.png";